import { call, put, delay, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/developer';
import snackbar from '~/store/ducks/snackbar';
import message from '~/store/ducks/message';
import api from '~/services/api';

function* loadWebhooks({ partner }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/webhook-urls`
    );

    yield put(actions.loadWebhooksSuccess(data ? data.request_url : null));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* saveWebhook({ partner, request_url, is_change }) {
  try {
    const { data } = yield call(
      is_change ? api.put : api.post,
      `/v1/partners/${partner}/webhook-urls`,
      { request_url }
    );

    yield put(actions.saveWebhookSuccess(data ? data.request_url : null));

    if (data) {
      yield put(
        snackbar.showSnackbar({
          color: 'success',
          icon: 'check',
          text: 'webhooks.save.success'
        })
      );

      yield delay(5000);
      yield put(snackbar.hideSnackbar());
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadTokens({ partner }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/systems?start=0&ordering=desc&count=999999`
    );

    yield put(actions.loadTokensSuccess(data ? data.entries : []));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* addToken({ partner, name, description }) {
  try {
    const { data } = yield call(api.post, `/v1/partners/${partner}/systems`, {
      name,
      description
    });

    const copyToClipboard = str => {
      const el = document.createElement('textarea');

      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';

      document.body.appendChild(el);

      el.select();
      el.setSelectionRange(0, 99999);

      document.execCommand('copy');
      document.body.removeChild(el);

      put(
        snackbar.showSnackbar({
          color: 'success',
          icon: 'check',
          text: 'token.copied'
        })
      );

      setTimeout(() => {
        put(snackbar.hideSnackbar());
      }, 5000);
    };

    if (data) {
      const alert = {
        type: 'warning',
        title: 'Token API',
        text: `Guarde essa chave em um local seguro pois você não poderá
                acessá-la novamente.
                ${data.token}
                `,
        actions: [
          {
            color: 'primary',
            text: 'Copiar',
            onClick: () => copyToClipboard(data.token)
          }
        ]
      };

      yield put(actions.loadTokens(partner));
      yield put(message.showMessage(alert));
    }

    yield put(actions.addTokenSuccess());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_WEBHOOKS, loadWebhooks),
  takeLatest(Types.SAVE_WEBHOOK, saveWebhook),
  takeLatest(Types.LOAD_TOKENS, loadTokens),
  takeLatest(Types.ADD_TOKEN, addToken)
];

export default sagas;
